
function ApplicationClosed() {
  return (
    <div>Applications have been closed</div>
  )
}

export default ApplicationClosed